import {ApplicationStoreType} from 'desktop/store';

import {MODULE_KEY_CHECKOUT} from '../constants';

/**
 * Get checkout edit step is loading
 * @param {ApplicationStoreType} store - current store
 * @return {boolean} - edit step is loading
 */
export const getEditStepLoading = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY_CHECKOUT].editStep.loading;

/**
 * Get checkout edit step error
 * @param {ApplicationStoreType} store - current store
 * @return {boolean} - edit step error
 */
export const getEditStepError = (store: ApplicationStoreType): string =>
    store[MODULE_KEY_CHECKOUT].editStep.error;
